"use client"
import {IAvisVerifiesResponse} from "@/app/endpoints/reviewEndpoint"
import Carousel from "@/app/components/atomic/molecules/Carousel"
import ReviewCard from "@/app/components/homepage/components/ReviewCard"

interface Props {
    reviews: IAvisVerifiesResponse[]
}

export default function ReviewCarousel({reviews}: Props) {
    const items = reviews.map((review) => (
        <ReviewCard key={review.id_review} review={review}/>
    ))

    return <Carousel items={items} lgPerPage={3}/>
}
